import Index from '@tunnel-components/@sharded/camera/segmentation/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/camera/segmentation/index.ts